import { useEffect, useRef, useState } from 'react'
import ConfirmationDialog from '@/Shared/Dialog/ConfirmationDialog'
import Helpers from '@/utils/helpers'
import { usePage } from '@inertiajs/react'

export default function TransactionSupportRequiredDialog({ transaction, requirements, shouldOpen, onSuccess, onClosed }) {
  let focusRef = useRef()
  const { user } = usePage().props.auth
  const associates = transaction.contacts.filter((tc) => tc.contact_type === 'Associate')
  const leadAssociate = associates.find((associate) => associate.is_transaction_owner)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (shouldOpen && !open) {
      setOpen(true)
    }
  }, [shouldOpen])

  const explanation = () => {
    let explanation = 'Transaction support is required'

    if (leadAssociate.contact.associate.id !== user.associate_id) {
      const leadAssociateName = leadAssociate.contact?.first_name
        ? `${leadAssociate.contact?.first_name} ${leadAssociate.contact?.last_name}`
        : leadAssociate.full_name

      explanation += ` for ${leadAssociateName}`
    }

    explanation += ' in order to update this transaction with the following checklist settings:'

    return explanation
  }

  const transactionSupportTeam = () => {
    let transactionStates = []

    if (transaction.property_state) {
      transactionStates = transactionStates.concat(transaction.property_state)
    } else if (transaction.states?.length > 0) {
      transactionStates = transaction.states.map((state) => state.value)
    }

    let svpContacts = leadAssociate.contact?.associate?.svpContacts

    let team = []

    if (svpContacts.length > 0) {
      team = team.concat(svpContacts[0])

      const stateSupervisors = svpContacts.filter((svp) =>
        svp.states_supervising.split(',')?.some((svpState) => transactionStates.includes(svpState)),
      )

      if (stateSupervisors.length > 0) {
        team = stateSupervisors
      }

      team = team.map((svp) => svp.name + ` (${svp.states_supervising})`)
    }

    return team.length > 0 ? Helpers.joinNames(team) : 'a Licensed Support Vice President'
  }

  return (
    <ConfirmationDialog
      focusRef={focusRef}
      buttonText="Ok, Continue"
      size="sm:max-w-2xl"
      open={open}
      title="Transaction Support Requirement Notice"
      onCanceled={() => setOpen(false)}
      onApproved={() => {
        setOpen(false)
        onSuccess()
      }}
      afterLeave={onClosed}
    >
      {shouldOpen && (
        <div className="mb-3 space-y-8">
          <p className="font-bold">{explanation()}</p>

          <div className="mx-auto max-w-sm overflow-hidden rounded-lg border border-gray-300 shadow">
            <table className="min-w-full divide-y divide-gray-300">
              <thead className="divide-x divide-gray-300 bg-gray-100">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-medium uppercase tracking-wider text-gray-600">Property Type</th>
                  <th className="px-4 py-3 text-center text-sm font-medium uppercase tracking-wider text-gray-600">State</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-300 bg-white">
                {requirements.map((requirement, index) => (
                  <tr className="divide-x divide-gray-300 font-bold" key={index}>
                    <td className="px-4 py-3">{requirement.property_type_name}</td>
                    <td className="px-4 py-3 text-center">{requirement.state}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p>
            By continuing, <b>{transactionSupportTeam()}</b> will be added to provide Transaction Support for this transaction.
          </p>
        </div>
      )}
    </ConfirmationDialog>
  )
}
